import React from 'react';
import { withRouter } from 'react-router-dom';

// Clears everything Login.js / Register.js saved, then goes to the login page.
const LOGIN_KEYS = ['email', 'userId', 'bio_slug', 'bio_url', 'balance', 'bioToken'];

function LogoutButton({ history, buttonStyle }) {
  const logout = () => {
    try {
      LOGIN_KEYS.forEach(key => localStorage.removeItem(key));
    } catch (err) {
      // storage unavailable: nothing saved to clear
    }
    history.push('/login');
  };

  return (
    <div>
      <button
        type="button"
        onClick={logout}
        style={buttonStyle || {
          margin: '4px',
          padding: '6px 14px',
          borderRadius: '6px',
          border: '1px solid #c62828',
          background: '#fff',
          color: '#c62828',
          cursor: 'pointer',
        }}
      >
        Logout
      </button>
    </div>
  );
}

export default withRouter(LogoutButton);
